import { max } from '@vee-validate/rules';
import { defineRule } from 'vee-validate';

defineRule('existing-sku', (value, args) => {
    const fn = Array.isArray(args) ? args[0] : args?.isExistingSku;
    if (typeof fn !== 'function') return true;
    return fn(value) || 'SKU does not match any existing product.';
});

export default {
    data() {
        return {
            productBarcodesConfiguration: {
                type: 'ProductBarcodes',
                label: 'Product Barcodes',
                sampleNotes: [
                    '"Include a SKU, Barcode, and IsDefault for each barcode to import."',
                    '"SKU must match an existing product."',
                    '"IsDefault: TRUE will set this barcode as the default and unset any existing default for that SKU."',
                    '"SortOrder is automatically calculated."',
                    '"Any errors on import can be reviewed in the Data Exchange Log."'
                ],
                fields: [
                    {
                        key: 'Sku',
                        label: 'SKU',
                        hasErrorCalculator: value => {
                            if (this.isEmpty(value)) {
                                return true;
                            }
                            if (max(value, { length: 20 }) !== true) {
                                return true;
                            }
                            return !this.isExistingSku(value);
                        },
                        rules: {
                            required: true,
                            max: { length: 20 },
                            'existing-sku': {
                                isExistingSku: this.isExistingSku
                            }
                        },
                        samples: ['"50000012"', '"50000013"']
                    },
                    {
                        key: 'Barcode',
                        label: 'Barcode',
                        hasErrorCalculator: (value) => {
                            if (this.isEmpty(value)) {
                                return true;
                            }
                            return max(value, { length: 128 }) !== true;
                        },
                        rules: {
                            required: true,
                            max: { length: 128 }
                        },
                        samples: ['"2235467890161"', '"1135467890171"']
                    },
                    {
                        key: 'IsDefault',
                        label: 'Is Default',
                        hasErrorCalculator: (value) => {
                            if (this.isEmpty(value)) {
                                return true;
                            }
                            let lower = (value + '').toLowerCase();
                            return lower !== 'true' && lower !== 'false';
                        },
                        rules: 'required',
                        samples: ['"TRUE"', '"FALSE"']
                    }
                ]
            }
        };
    },
    methods: {
        isExistingSku(value) {
            if (this.isEmpty(value)) {
                return false;
            }
            return this.existingSkus.has(value + '');
        }
    }
};
